import { useTranslation } from 'react-i18next';
import { useMerchantInfo } from './use-merchant-info';
import { useCardBrand } from './use-card-brand';
import { useFormFeedback } from '@tectonics/components/form/hooks/use-form-feedback';
import { LEGACY_COPY } from '../legacy-copy';
import type { LegacyCopyNamespace } from '../legacy-copy';

function useSecurityCodeErrorMessage(value: string, legacyNamespace: LegacyCopyNamespace): string | null {
  const { t } = useTranslation('opened-page', { keyPrefix: 'volcanes.form.cardSecurityCode' });
  const { t: tLegacy } = useTranslation(legacyNamespace);
  const { errorKeys, fallbackErrorKey } = LEGACY_COPY[legacyNamespace];

  const { isDemoMerchant } = useMerchantInfo();
  const { cardDigits } = useCardBrand();
  const { validationError } = useFormFeedback('cardSecurityCode');

  if (!validationError) return null;

  if (!isDemoMerchant) {
    return tLegacy(errorKeys[validationError.id] ?? fallbackErrorKey);
  }

  if (validationError.id === 'empty') return t('errorEmpty');

  if (validationError.id === 'invalid-pattern' && value.length < cardDigits) {
    return t('errorIncomplete', { digits: cardDigits });
  }

  return t('errorInvalid');
}

export { useSecurityCodeErrorMessage };
